import React from 'react';

export default function Legend({ items = [] }) {
  if (!items || items.length === 0) return null;
  return (
    <div className="flex flex-wrap items-center gap-2 text-xs">
      {items.map((it, idx) => (
        <div key={idx} className="flex items-center gap-1">
          <span className="inline-block w-3 h-3 rounded" style={{ background: it.color }} />
          <span className="text-gray-700 dark:text-gray-300">{it.label}</span>
        </div>
      ))}
    </div>
  );
}
